const apnaCollege = [
  {
    topicName: "Array",
    position: 0,
    started: false,
    doneQuestions: 0,
    questions: [
      {
        Topic: "Arrays",
        Problem: "Maximum and Minimum Element in an Array",
        Done: false,
        URL: "https://www.geeksforgeeks.org/maximum-and-minimum-in-an-array/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Arrays",
        Problem: "Reverse the Array",
        Done: false,
        URL: "https://www.geeksforgeeks.org/write-a-program-to-reverse-an-array-or-string/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Arrays",
        Problem: "MAximum-Subarray",
        Done: false,
        URL: "https://leetcode.com/problems/maximum-subarray/",
        Platform: "leetcode",
      },
      {
        Topic: "Arrays",
        Problem: "Contains Duplicate",
        Done: false,
        URL: "https://leetcode.com/problems/contains-duplicate/",
        Platform: "leetcode",
      },
      {
        Topic: "Arrays",
        Problem: "Chocolate Distribution Problem",
        Done: false,
        URL: "https://www.geeksforgeeks.org/chocolate-distribution-problem/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Arrays",
        Problem: "Search in Rotated Sorted array ",
        Done: false,
        URL: "https://leetcode.com/problems/search-in-rotated-sorted-array/",
        Platform: "leetcode",
      },
      {
        Topic: "Arrays",
        Problem: "Next Permutation",
        Done: false,
        URL: "https://leetcode.com/problems/next-permutation/",
        Platform: "leetcode",
      },
      {
        Topic: "Arrays",
        Problem: "Best time to buy and sell stock",
        Done: false,
        URL: "https://leetcode.com/problems/best-time-to-buy-and-sell-stock/",
        Platform: "leetcode",
      },
      {
        Topic: "Arrays",
        Problem: "Repeat and missing number array",
        Done: false,
        URL: "https://www.interviewbit.com/problems/repeat-and-missing-number-array/",
        Platform: "interviewbit",
      },
      {
        Topic: "Arrays",
        Problem: "Kth largest element in an array",
        Done: false,
        URL: "https://leetcode.com/problems/kth-largest-element-in-an-array/",
        Platform: "leetcode",
      },
      {
        Topic: "Arrays",
        Problem: "Trapping rain water",
        Done: false,
        URL: "https://leetcode.com/problems/trapping-rain-water/",
        Platform: "leetcode",
      },
      {
        Topic: "Arrays",
        Problem: "Product of array except self",
        Done: false,
        URL: "https://leetcode.com/problems/product-of-array-except-self/",
        Platform: "leetcode",
      },
      {
        Topic: "Arrays",
        Problem: "Maximum product subarray",
        Done: false,
        URL: "https://leetcode.com/problems/maximum-product-subarray/",
        Platform: "leetcode",
      },
      {
        Topic: "Arrays",
        Problem: "Find the mainimum in rotated sorted array",
        Done: false,
        URL: "https://leetcode.com/problems/find-minimum-in-rotated-sorted-array/",
        Platform: "leetcode",
      },
      {
        Topic: "Arrays",
        Problem: "Find pair with sum in sorted and rotated array",
        Done: false,
        URL: "https://www.geeksforgeeks.org/given-a-sorted-and-rotated-array-find-if-there-is-a-pair-with-a-given-sum/?ref=lbp",
        Platform: "geekforgeeks",
      },
      {
        Topic: "Arrays",
        Problem: "3Sum",
        Done: false,
        URL: "https://leetcode.com/problems/3sum/",
        Platform: "leetcode",
      },
      {
        Topic: "Arrays",
        Problem: "Container with the most water",
        Done: false,
        URL: "https://leetcode.com/problems/container-with-most-water/",
        Platform: "leetcode",
      },
      {
        Topic: "Arrays",
        Problem: "Given sum pair",
        Done: false,
        URL: "https://www.geeksforgeeks.org/given-a-sorted-and-rotated-array-find-if-there-is-a-pair-with-a-given-sum/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Arrays",
        Problem: "Kth smallest element",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/kth-smallest-element5635/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Arrays",
        Problem: "Merge overlapping elements",
        Done: false,
        URL: "https://www.geeksforgeeks.org/merging-intervals/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Arrays",
        Problem:
          "Find minimum no. of merge operations to make an array palindrome",
        Done: false,
        URL: "https://www.geeksforgeeks.org/find-minimum-number-of-merge-operations-to-make-an-array-palindrome/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Arrays",
        Problem:
          "Given an array of numbers, arrange the numbers to form the biggest number",
        Done: false,
        URL: "https://www.geeksforgeeks.org/given-an-array-of-numbers-arrange-the-numbers-to-form-the-biggest-number/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Arrays",
        Problem: "Space optimization using bit manipulators",
        Done: false,
        URL: "https://www.geeksforgeeks.org/space-optimization-using-bit-manipulations/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Arrays",
        Problem: "Subarray sum divisible K",
        Done: false,
        URL: "https://www.geeksforgeeks.org/longest-subarray-sum-divisible-k/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Arrays",
        Problem:
          "Print all possible combinations of r elements in a given array of size n",
        Done: false,
        URL: "https://www.geeksforgeeks.org/print-all-possible-combinations-of-r-elements-in-a-given-array-of-size-n/",
        Platform: "geekgorgeeks",
      },
      {
        Topic: "Arrays",
        Problem: "Mo's algorithm",
        Done: false,
        URL: "hhttps://www.geeksforgeeks.org/mos-algorithm-query-square-root-decomposition-set-1-introduction/",
        Platform: "geekforgeeks",
      },
    ],
  },
  {
    topicName: "Strings",
    position: 1,
    started: false,
    doneQuestions: 0,
    questions: [
      {
        Topic: "Strings",
        Problem: "Valid Palindrome",
        Done: false,
        URL: "https://leetcode.com/problems/valid-palindrome/",
        Platform: "leetcode",
      },
      {
        Topic: "Strings",
        Problem: "Valid Anagram",
        Done: false,
        URL: "https://leetcode.com/problems/valid-anagram/",
        Platform: "leetcode",
      },
      {
        Topic: "Strings",
        Problem: "Valid parantheses",
        Done: false,
        URL: "https://leetcode.com/problems/valid-parentheses/",
        Platform: "leetcode",
      },
      {
        Topic: "Strings",
        Problem: "Remove consecutive Characters",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/consecutive-elements2306/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Strings",
        Problem: "Longest Common Prefix",
        Done: false,
        URL: "https://leetcode.com/problems/longest-common-prefix/",
        Platform: "leetcode",
      },
      {
        Topic: "Strings",
        Problem:
          "Convert a sentence into its equivalent mobile numeric keypad sequence",
        Done: false,
        URL: "https://www.geeksforgeeks.org/convert-sentence-equivalent-mobile-numeric-keypad-sequence/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Strings",
        Problem: "Print all the duplicates in Input strings",
        Done: false,
        URL: "https://www.geeksforgeeks.org/print-all-the-duplicates-in-the-input-string/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Strings",
        Problem: "Longest sub-string without repeating characters",
        Done: false,
        URL: "https://leetcode.com/problems/longest-substring-without-repeating-characters/",
        Platform: "leetcode",
      },
      {
        Topic: "Strings",
        Problem: "Longest repeating character replacement",
        Done: false,
        URL: "https://leetcode.com/problems/longest-repeating-character-replacement/",
        Platform: "leetcode",
      },
      {
        Topic: "Strings",
        Problem: "Longest palindromic substring ",
        Done: false,
        URL: "https://leetcode.com/problems/longest-palindromic-substring/",
        Platform: "leetcode",
      },
      {
        Topic: "Strings",
        Problem: "Palindromic substrings",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/spirally-traversing-a-matrix/0",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Strings",
        Problem: "Next Permutation",
        Done: false,
        URL: "https://leetcode.com/problems/search-a-2d-matrix/",
        Platform: "leetcode",
      },
      {
        Topic: "Strings",
        Problem: "COunt Palindromic Subsequences",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/median-in-a-row-wise-sorted-matrix1527/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Strings",
        Problem:
          "Smallest window in a string containing all the characters of another string",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/row-with-max-1s0023/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Strings",
        Problem: "Wildcard string matching",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/sorted-matrix/0",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Strings",
        Problem: "Longest prefix suffix",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/max-rectangle/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Strings",
        Problem: "Rabin-Karp algorithm for pattern searching",
        Done: false,
        URL: "https://leetcode.com/problems/rotate-image/",
        Platform: "leetcode",
      },
      {
        Topic: "Strings",
        Problem:
          "Transform one string into another using minimum number of given operation",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/kth-element-in-matrix/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Strings",
        Problem: "Minimum window substring",
        Done: false,
        URL: "https://leetcode.com/problems/minimum-window-substring/",
        Platform: "leetcode",
      },
      {
        Topic: "Strings",
        Problem: "Boyer Moore Algorithm for pattern searching",
        Done: false,
        URL: "https://www.geeksforgeeks.org/boyer-moore-algorithm-for-pattern-searching/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Strings",
        Problem: "Word Wrap",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/word-wrap1646/1",
        Platform: "geekforgeeks",
      },
    ],
  },
  {
    topicName: "Matrix",
    position: 2,
    started: false,
    doneQuestions: 0,
    questions: [
      {
        Topic: "2D Arrays",
        Problem: "Zigzag traversal of matrix",
        Done: false,
        URL: "https://www.geeksforgeeks.org/zigzag-or-diagonal-traversal-of-matrix/",
        Platform: "geekforgeeks",
      },
      {
        Topic: "2D Arrays",
        Problem: "Set matrix zeroes",
        Done: false,
        URL: "https://leetcode.com/problems/set-matrix-zeroes/",
        Platform: "leetcode",
      },
      {
        Topic: "2D Arrays",
        Problem: "Spiral Matrix",
        Done: false,
        URL: "https://leetcode.com/problems/spiral-matrix/",
        Platform: "leetcode",
      },
      {
        Topic: "2D Arrays",
        Problem: "Rotate image",
        Done: false,
        URL: "https://leetcode.com/problems/rotate-image/",
        Platform: "leetcode",
      },
      {
        Topic: "2D Arrays",
        Problem: "Word search",
        Done: false,
        URL: "https://leetcode.com/problems/word-search/",
        Platform: "leetcode",
      },
      {
        Topic: "2D Arrays",
        Problem: "Find the number of islands | Set 1(using DFS)",
        Done: false,
        URL: "https://www.geeksforgeeks.org/find-the-number-of-islands-using-dfs/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "2D Arrays",
        Problem:
          "Given a matrix of'O' amd 'X', replace 'O' with 'X' if surrounded by'X'.",
        Done: false,
        URL: "https://www.geeksforgeeks.org/given-matrix-o-x-replace-o-x-surrounded-x/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "2D Arrays",
        Problem:
          "Find a common element in all rows of a given row-wise sorted matrix",
        Done: false,
        URL: "https://www.geeksforgeeks.org/find-common-element-rows-row-wise-sorted-matrix/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "2D Arrays",
        Problem: "Create a matrix with alternating rectangles of O and X.",
        Done: false,
        URL: "https://www.geeksforgeeks.org/create-a-matrix-with-alternating-rectangles-of-0-and-x/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "2D Arrays",
        Problem: "Maximum size rectangle of all 1s",
        Done: false,
        URL: "https://www.geeksforgeeks.org/maximum-size-rectangle-binary-sub-matrix-1s/",
        Platform: "geekforgeeks",
      },
    ],
  },
  {
    topicName: "Searching & Sorting",
    position: 3,
    started: false,
    doneQuestions: 0,
    questions: [
      {
        Topic: "Searching & Sorting",
        Problem:
          "Permute two arrays such that sum of every pair is greater or equal to K",
        Done: false,
        URL: "https://www.geeksforgeeks.org/permute-two-arrays-sum-every-pair-greater-equal-k/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Searching & Sorting",
        Problem: "Conting sort",
        Done: false,
        URL: "https://www.geeksforgeeks.org/counting-sort/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Searching & Sorting",
        Problem: "Find common elements three sorted arrays",
        Done: false,
        URL: "https://www.geeksforgeeks.org/find-common-elements-three-sorted-arrays/",
        Platform: "leetcode",
      },
      {
        Topic: "Searching & Sorting",
        Problem: "Searching in an array where adjacent differ by at most k",
        Done: false,
        URL: "https://www.geeksforgeeks.org/searching-array-adjacent-differ-k/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Searching & Sorting",
        Problem: "Ceiling in a sorted array",
        Done: false,
        URL: "https://www.geeksforgeeks.org/ceiling-in-a-sorted-array/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Searching & Sorting",
        Problem: "Piar with given difference",
        Done: false,
        URL: "https://www.geeksforgeeks.org/find-a-pair-with-the-given-difference/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Searching & Sorting",
        Problem: "Majority element",
        Done: false,
        URL: "https://www.geeksforgeeks.org/majority-element/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Searching & Sorting",
        Problem: "Count triplets with sum smaller that a given value",
        Done: false,
        URL: "https://www.geeksforgeeks.org/count-triplets-with-sum-smaller-that-a-given-value/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Searching & Sorting",
        Problem: "Maximum sum subsequence with no adjacent elements ",
        Done: false,
        URL: "https://www.geeksforgeeks.org/maximum-sum-such-that-no-two-elements-are-adjacent/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Searching & Sorting",
        Problem: "Merge sorted arrays using O(1) space",
        Done: false,
        URL: "https://www.geeksforgeeks.org/merge-two-sorted-arrays-o1-extra-space/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Searching & Sorting",
        Problem: "Inversion of array",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/inversion-of-array-1587115620/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Searching & Sorting",
        Problem: "Find duplicates in O(n) time and O(1) extra space",
        Done: false,
        URL: "https://www.geeksforgeeks.org/find-duplicates-in-on-time-and-constant-extra-space/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Searching & Sorting",
        Problem: "Radix sort",
        Done: false,
        URL: "https://www.geeksforgeeks.org/radix-sort/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Searching & Sorting",
        Problem: "Product of array except itself",
        Done: false,
        URL: "https://www.geeksforgeeks.org/a-product-array-puzzle/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Searching & Sorting",
        Problem: "Make all array elements equal",
        Done: false,
        URL: "https://www.geeksforgeeks.org/a-product-array-puzzle/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Searching & Sorting",
        Problem: "Check of reversing a sub array makes the arrray sorted.",
        Done: false,
        URL: "https://www.geeksforgeeks.org/check-reversing-sub-array-make-array-sorted/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Searching & Sorting",
        Problem: "Find four elements that sum to a given value",
        Done: false,
        URL: "https://www.geeksforgeeks.org/find-four-elements-that-sum-to-a-given-value-set-2/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Searching & Sorting",
        Problem: "Median of two sorted arrays wiit different sizes",
        Done: false,
        URL: "https://www.geeksforgeeks.org/median-of-two-sorted-arrays-of-different-sizes/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Searching & Sorting",
        Problem: "Median of stream of integers running integers",
        Done: false,
        URL: "https://www.geeksforgeeks.org/median-of-stream-of-integers-running-integers/",
        Platform: "geekforgeeks",
      },
      {
        Topic: "Searching & Sorting",
        Problem: "Print sub arrays with 0 sum",
        Done: false,
        URL: "https://www.geeksforgeeks.org/print-all-subarrays-with-0-sum/",
        Platform: "geekforgeeks",
      },
      {
        Topic: "Searching & Sorting",
        Problem: "Aggressive cows",
        Done: false,
        URL: "https://www.spoj.com/problems/AGGRCOW/",
        Platform: "spoi",
      },
      {
        Topic: "Searching & Sorting",
        Problem: "Allocate minimum number of pages",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/allocate-minimum-number-of-pages0937/1",
        Platform: "geekforgeeks",
      },
      {
        Topic: "Searching & Sorting",
        Problem: "Minimum swaps to sort",
        Done: false,
        URL: "https://www.geeksforgeeks.org/minimum-number-swaps-required-sort-array/",
        Platform: "geeksforgeeks",
      },
    ],
  },
  {
    topicName: "Linked List",
    position: 4,
    started: false,
    doneQuestions: 0,
    questions: [
      {
        Topic: "LinkedList",
        Problem:
          "Write a Program to reverse the Linked List. (Both Iterative and recursive)",
        Done: false,
        URL: "https://leetcode.com/problems/reverse-linked-list/",
        Platform: "leetcode",
      },
      {
        Topic: "LinkedList",
        Problem: "Linked list cycle",
        Done: false,
        URL: "https://leetcode.com/problems/linked-list-cycle/",
        Platform: "leetcode",
      },
      {
        Topic: "LinkedList",
        Problem: "Merge two sorted lists",
        Done: false,
        URL: "https://leetcode.com/problems/merge-two-sorted-lists/",
        Platform: "leetcode",
      },
      {
        Topic: "LinkedList",
        Problem: "Delete without head node",
        Done: false,
        URL: "https://www.geeksforgeeks.org/given-only-a-pointer-to-a-node-to-be-deleted-in-a-singly-linked-list-how-do-you-delete-it/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "LinkedList",
        Problem: "Remove duplicates from an unsorted linked-list",
        Done: false,
        URL: "https://www.geeksforgeeks.org/remove-duplicates-from-an-unsorted-linked-list/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "LinkedList",
        Problem: "sort a linked list of 0's or 1's ",
        Done: false,
        URL: "https://www.geeksforgeeks.org/sort-a-linked-list-of-0s-1s-or-2s/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "LinkedList",
        Problem: "Multiply two numbers represented linked list",
        Done: false,
        URL: "https://www.geeksforgeeks.org/multiply-two-numbers-represented-linked-lists/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "LinkedList",
        Problem: "Remove nth node from end of list",
        Done: false,
        URL: "https://leetcode.com/problems/remove-nth-node-from-end-of-list/",
        Platform: "leetcode",
      },
      {
        Topic: "LinkedList",
        Problem: "Reorder list",
        Done: false,
        URL: "https://leetcode.com/problems/reorder-list/",
        Platform: "leetcode",
      },
      {
        Topic: "LinkedList",
        Problem: "Detect and remove loop in a linked list",
        Done: false,
        URL: "https://www.geeksforgeeks.org/detect-and-remove-loop-in-a-linked-list/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "LinkedList",
        Problem: "Delete nodes which have a greater value on right side.",
        Done: false,
        URL: "https://www.geeksforgeeks.org/delete-nodes-which-have-a-greater-value-on-right-side/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "LinkedList",
        Problem: "Segregate even and odd elements in a linked list.",
        Done: false,
        URL: "https://www.geeksforgeeks.org/segregate-even-and-odd-elements-in-a-linked-list/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "LinkedList",
        Problem:
          "Point to next higher value node in a linked list with an arbitary pointer",
        Done: false,
        URL: "https://www.geeksforgeeks.org/point-to-next-higher-value-node-in-a-linked-list-with-an-arbitrary-pointer/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "LinkedList",
        Problem: "Rearrange a given linked list in place",
        Done: false,
        URL: "https://www.geeksforgeeks.org/rearrange-a-given-linked-list-in-place/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "LinkedList",
        Problem: "Sort biotonic Douby linked list",
        Done: false,
        URL: "https://www.geeksforgeeks.org/rearrange-a-given-linked-list-in-place/",
        Platform: "geekforgeeks",
      },
      {
        Topic: "LinkedList",
        Problem: "Merge K sorted list",
        Done: false,
        URL: "https://leetcode.com/problems/merge-k-sorted-lists/",
        Platform: "leetcode",
      },
      {
        Topic: "LinkedList",
        Problem: "Merge sort for linked list",
        Done: false,
        URL: "https://www.geeksforgeeks.org/merge-sort-for-linked-list/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "LinkedList",
        Problem: "Quicksort on singly-linked list",
        Done: false,
        URL: "https://www.geeksforgeeks.org/quicksort-on-singly-linked-list/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "LinkedList",
        Problem: "Sum of two linked list",
        Done: false,
        URL: "https://www.geeksforgeeks.org/sum-of-two-linked-lists/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "LinkedList",
        Problem: "Flattening a linked list",
        Done: false,
        URL: "https://www.geeksforgeeks.org/flattening-a-linked-list/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "LinkedList",
        Problem: "Clone a linked list with next and random pointer",
        Done: false,
        URL: "https://www.geeksforgeeks.org/a-linked-list-with-next-and-arbit-pointer/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "LinkedList",
        Problem: "Subtract two numbers represented as linked list",
        Done: false,
        URL: "https://www.geeksforgeeks.org/subtract-two-numbers-represented-as-linked-lists/",
        Platform: "geeksforgeeks",
      },
    ],
  },
  {
    topicName: "Binary Trees",
    position: 5,
    started: false,
    doneQuestions: 0,
    questions: [
      {
        Topic: "Binary Trees",
        Problem: "Maximum depth of binary tree",
        Done: false,
        URL: "https://leetcode.com/problems/maximum-depth-of-binary-tree/",
        Platform: "leetcode",
      },
      {
        Topic: "Binary Trees",
        Problem: "Reverse Level Order traversal",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/reverse-level-order-traversal/1",
        Platform: "geekforgeeks",
      },
      {
        Topic: "Binary Trees",
        Problem: "Subtree of another tree",
        Done: false,
        URL: "https://leetcode.com/problems/subtree-of-another-tree/",
        Platform: "leetcode",
      },
      {
        Topic: "Binary Trees",
        Problem: "Invert binary tree",
        Done: false,
        URL: "https://leetcode.com/problems/invert-binary-tree/",
        Platform: "leetcode",
      },
      {
        Topic: "Binary Trees",
        Problem: "Binary tree level order traversal",
        Done: false,
        URL: "https://leetcode.com/problems/binary-tree-level-order-traversal/",
        Platform: "leetcode",
      },
      {
        Topic: "Binary Trees",
        Problem: "Left view of binary tree",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/left-view-of-binary-tree/1",
        Platform: "geekforgeeks",
      },
      {
        Topic: "Binary Trees",
        Problem: "Right view of binary tree",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/right-view-of-binary-tree/1",
        Platform: "geekforgeeks",
      },
      {
        Topic: "Binary Trees",
        Problem: "ZigZag tree traversal",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/zigzag-tree-traversal/1",
        Platform: "geekforgeeks",
      },
      {
        Topic: "Binary Trees",
        Problem: "Create a mirror tree from the given binary tree",
        Done: false,
        URL: "https://www.geeksforgeeks.org/create-a-mirror-tree-from-the-given-binary-tree/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Binary Trees",
        Problem: "Leaf at same level",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/leaf-at-same-level/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Binary Trees",
        Problem: "Check for balanced tree",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/check-for-balanced-tree/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Binary Trees",
        Problem: "Transform to sum tree",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/transform-to-sum-tree/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Binary Trees",
        Problem: "Check if tree is isomorphic",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/check-if-tree-is-isomorphic/1",
        Platform: "geekforgeeks",
      },
      {
        Topic: "Binary Trees",
        Problem: "Same tree",
        Done: false,
        URL: "https://leetcode.com/problems/same-tree/",
        Platform: "leetcode",
      },
      {
        Topic: "Binary Trees",
        Problem: "Construct binary tree from pre-order and inorder traversal",
        Done: false,
        URL: "https://leetcode.com/problems/construct-binary-tree-from-preorder-and-inorder-traversal/",
        Platform: "leetcode",
      },
      {
        Topic: "Binary Trees",
        Problem: "Height of binary tree",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/height-of-binary-tree/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Binary Trees",
        Problem: "Diameter of binary tree",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/diameter-of-binary-tree/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Binary Trees",
        Problem: "Top view of bianry tree",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/top-view-of-binary-tree/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Binary Trees",
        Problem: "Bottom view of bianry tree",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/bottom-view-of-binary-tree/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Binary Trees",
        Problem: "Diagonal traversal of binary tree",
        Done: false,
        URL: "https://www.geeksforgeeks.org/diagonal-traversal-of-binary-tree/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Binary Trees",
        Problem: "Boundary traversal of binary tree",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/boundary-traversal-of-binary-tree/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Binary Trees",
        Problem: "Construct binary tree from string and brackets",
        Done: false,
        URL: "https://www.geeksforgeeks.org/construct-binary-tree-string-bracket-representation/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Binary Trees",
        Problem:
          "Minimum swap requied to convert binary tree to binary search tree",
        Done: false,
        URL: "https://www.geeksforgeeks.org/minimum-swap-required-convert-binary-tree-binary-search-tree/#:~:text=Given%20the%20array%20representation%20of,it%20into%20Binary%20Search%20Tree.&text=Swap%201%3A%20Swap%20node%208,node%209%20with%20node%2010.",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Binary Trees",
        Problem: "Duplicate subtree in binary tree",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/duplicate-subtree-in-binary-tree/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Binary Trees",
        Problem: "Check if a given graph is tree or not",
        Done: false,
        URL: "https://www.geeksforgeeks.org/check-given-graph-tree/#:~:text=Since%20the%20graph%20is%20undirected,graph%20is%20connected%2C%20otherwise%20not.",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Binary Trees",
        Problem: "Lowest common ancestor in binary tree",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/lowest-common-ancestor-in-a-binary-tree/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Binary Trees",
        Problem: "Minimum distance between two given nodes of a binary tree",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/min-distance-between-two-given-nodes-of-a-binary-tree/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Binary Trees",
        Problem: "Duplicate subtrees",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/duplicate-subtrees/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Binary Trees",
        Problem: "Kth ancestor of a node in binary tree",
        Done: false,
        URL: "https://www.geeksforgeeks.org/kth-ancestor-node-binary-tree-set-2/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Binary Trees",
        Problem: "Binary tree maximum path sum",
        Done: false,
        URL: "https://leetcode.com/problems/binary-tree-maximum-path-sum/",
        Platform: "leetcode",
      },
      {
        Topic: "Binary Trees",
        Problem: "Serialize and deserialize binary tree",
        Done: false,
        URL: "https://leetcode.com/problems/serialize-and-deserialize-binary-tree/",
        Platform: "leetcode",
      },
      {
        Topic: "Binary Trees",
        Problem: "Binary tree to DLL",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/binary-tree-to-dll/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Binary Trees",
        Problem: "Print all k-sum paths in a binary tree",
        Done: false,
        URL: "https://www.geeksforgeeks.org/print-k-sum-paths-binary-tree/",
        Platform: "geeksforgeeks",
      },
    ],
  },
  {
    topicName: "BST",
    position: 6,
    started: false,
    doneQuestions: 0,
    questions: [
      {
        Topic: "Binary Search Trees",
        Problem: "Lowest common ancestor of a binary search tree",
        Done: false,
        URL: "https://leetcode.com/problems/lowest-common-ancestor-of-a-binary-search-tree/",
        Platform: "leetcode",
      },
      {
        Topic: "Binary Search Trees",
        Problem: "Binary search tree | set 1(search and insertion)",
        Done: false,
        URL: "https://www.geeksforgeeks.org/binary-search-tree-set-1-search-and-insertion/",
        Platform: "geekforgeeks",
      },
      {
        Topic: "Binary Search Trees",
        Problem: "Minimum element in BST",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/minimum-element-in-bst/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Binary Search Trees",
        Problem: "Predecessor and successor",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/predecessor-and-successor/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Binary Search Trees",
        Problem: "Check whether BST contain dead end or not",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/check-whether-bst-contains-dead-end/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Binary Search Trees",
        Problem: "Binary tree to BST",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/binary-tree-to-bst/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Binary Search Trees",
        Problem: "Kth largest element in BST",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/kth-largest-element-in-bst/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Binary Search Trees",
        Problem: "Validate BST",
        Done: false,
        URL: "https://leetcode.com/problems/validate-binary-search-tree/",
        Platform: "leetcode",
      },
      {
        Topic: "Binary Search Trees",
        Problem: "Kth smallest element in BST",
        Done: false,
        URL: "https://leetcode.com/problems/kth-smallest-element-in-a-bst/",
        Platform: "leetcode",
      },
      {
        Topic: "Binary Search Trees",
        Problem: "Delete node in a BST",
        Done: false,
        URL: "https://leetcode.com/problems/delete-node-in-a-bst/",
        Platform: "leetcode",
      },
      {
        Topic: "Binary Search Trees",
        Problem: "Flatten BST to sorted list",
        Done: false,
        URL: "https://www.geeksforgeeks.org/flatten-bst-to-sorted-list-increasing-order/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Binary Search Trees",
        Problem: "Preorder to postorder",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/preorder-to-postorder4423/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Binary Search Trees",
        Problem: "Count BST nodes that lie in a given range",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/count-bst-nodes-that-lie-in-a-given-range/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Binary Search Trees",
        Problem: "Populate inorder successor for all nodes",
        Done: false,
        URL: "hhttps://practice.geeksforgeeks.org/problems/populate-inorder-successor-for-all-nodes/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Binary Search Trees",
        Problem: "Convert normal BST into balanced BST",
        Done: false,
        URL: "https://www.geeksforgeeks.org/convert-normal-bst-balanced-bst/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Binary Search Trees",
        Problem: "Merge two BSTs",
        Done: false,
        URL: "https://www.geeksforgeeks.org/merge-two-balanced-binary-search-trees/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Binary Search Trees",
        Problem: "Given n appointments, find all conflicting appointments",
        Done: false,
        URL: "https://www.geeksforgeeks.org/given-n-appointments-find-conflicting-appointments/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Binary Search Trees",
        Problem: "Replace every element",
        Done: false,
        URL: "https://www.geeksforgeeks.org/replace-every-element-with-the-least-greater-element-on-its-right/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Binary Search Trees",
        Problem: "Construct BST from a given preorder traversal",
        Done: false,
        URL: "https://www.geeksforgeeks.org/construct-bst-from-given-preorder-traversa/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Binary Search Trees",
        Problem: "Find median of BST in O(n) time and O(1) space",
        Done: false,
        URL: "https://www.geeksforgeeks.org/find-median-bst-time-o1-space/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Binary Search Trees",
        Problem: "Largest BST in a Binary Tree",
        Done: false,
        URL: "https://www.geeksforgeeks.org/largest-bst-binary-tree-set-2/",
        Platform: "geeksforgeeks",
      },
    ],
  },
  {
    topicName: "Greedy",
    position: 7,
    started: false,
    doneQuestions: 0,
    questions: [
      {
        Topic: "Greedy",
        Problem: "Activity Selection Problem",
        Done: false,
        URL: "https://www.geeksforgeeks.org/activity-selection-problem-greedy-algo-1/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Greedy",
        Problem: "Greedy algorithm to find minimum no. of coins",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/johttps://www.geeksforgeeks.org/greedy-algorithm-to-find-minimum-number-of-coins/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Greedy",
        Problem: "Minimum sum numbers formed digits array-2",
        Done: false,
        URL: "https://www.geeksforgeeks.org/minimum-sum-two-numbers-formed-digits-array-2/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Greedy",
        Problem: "Minimum sum absolute difference pairs two arrays",
        Done: false,
        URL: "https://www.geeksforgeeks.org/minimum-sum-absolute-difference-pairs-two-arrays/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Greedy",
        Problem: "Find maximum height pyramid from given array of objects",
        Done: false,
        URL: "https://www.geeksforgeeks.org/find-maximum-height-pyramid-from-the-given-array-of-objects/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Greedy",
        Problem:
          "Minimum cost for acquiring all coins with k extra coins allowed with every coin",
        Done: false,
        URL: "https://www.geeksforgeeks.org/minimum-cost-for-acquiring-all-coins-with-k-extra-coins-allowed-with-every-coin/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Greedy",
        Problem: "Find maximum equal sum of every three stacks",
        Done: false,
        URL: "https://www.geeksforgeeks.org/find-maximum-sum-possible-equal-sum-three-stacks/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Greedy",
        Problem: "Job sequencing problem",
        Done: false,
        URL: "https://www.geeksforgeeks.org/job-sequencing-problem/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Greedy",
        Problem: "Greedy algorithm egyptian fraction",
        Done: false,
        URL: "https://www.geeksforgeeks.org/greedy-algorithm-egyptian-fraction/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Greedy",
        Problem: "Fractional knapsack problem",
        Done: false,
        URL: "https://www.geeksforgeeks.org/fractional-knapsack-problem/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Greedy",
        Problem: "Maximum length chain of pairs",
        Done: false,
        URL: "https://www.geeksforgeeks.org/maximum-length-chain-of-pairs-dp-20/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Greedy",
        Problem: "Find smallest no. with given number of digits and digit sum",
        Done: false,
        URL: "https://www.geeksforgeeks.org/find-smallest-number-with-given-number-of-digits-and-digit-sum/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Greedy",
        Problem: "Maximize sum of consecutive differences circular array",
        Done: false,
        URL: "https://www.geeksforgeeks.org/maximize-sum-consecutive-differences-circular-array/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Greedy",
        Problem: "Paper cut minimum no. squares",
        Done: false,
        URL: "https://www.geeksforgeeks.org/paper-cut-minimum-number-squares/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Greedy",
        Problem: "Lexicographically smallest array k consecutive swaps",
        Done: false,
        URL: "https://www.geeksforgeeks.org/lexicographically-smallest-array-k-consecutive-swaps/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Greedy",
        Problem: "Problems CHOCOLA",
        Done: false,
        URL: "https://www.spoj.com/problems/CHOCOLA/",
        Platform: "spoj",
      },
      {
        Topic: "Greedy",
        Problem: "Find minimum time to finish all jobs with given constraints",
        Done: false,
        URL: "https://www.geeksforgeeks.org/find-minimum-time-to-finish-all-jobs-with-given-constraints/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Greedy",
        Problem: "Job sequencing using disjoint set union",
        Done: false,
        URL: "https://www.geeksforgeeks.org/job-sequencing-problem-using-disjoint-set/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Greedy",
        Problem:
          "Rearrange characters string such that no two adjacent are same",
        Done: false,
        URL: "https://www.geeksforgeeks.org/rearrange-characters-string-no-two-adjacent/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Greedy",
        Problem:
          "Minimum edges to reverse to make path from a source to a destination",
        Done: false,
        URL: "https://www.geeksforgeeks.org/minimum-edges-reverse-make-path-source-destination/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Greedy",
        Problem:
          "Minimum cash flow among a given set of friends who have borrowed money from each other",
        Done: false,
        URL: "https://www.geeksforgeeks.org/minimize-cash-flow-among-given-set-friends-borrowed-money/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Greedy",
        Problem: "Minimum cost to cut a board into squares",
        Done: false,
        URL: "https://www.geeksforgeeks.org/minimum-cost-cut-board-squares/",
        Platform: "geeksforgeeks",
      },
    ],
  },
  {
    topicName: "BackTracking",
    position: 8,
    started: false,
    doneQuestions: 0,
    questions: [
      {
        Topic: "BackTracking",
        Problem: "Backtracking set 2 rat in a maze",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/rat-in-a-maze-problem/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "BackTracking",
        Problem: "Combinational sum",
        Done: false,
        URL: "https://www.geeksforgeeks.org/combinational-sum/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "BackTracking",
        Problem: "Crossword puzzle",
        Done: false,
        URL: "https://www.hackerrank.com/challenges/crossword-puzzle/problem",
        Platform: "hackerrank",
      },
      {
        Topic: "BackTracking",
        Problem: "Longest possible route in a matrix with hurdles",
        Done: false,
        URL: "https://www.geeksforgeeks.org/longest-possible-route-in-a-matrix-with-hurdles/",
        Platform: "geekforgeeks",
      },
      {
        Topic: "BackTracking",
        Problem: "Printing all solutions in N-Queen problem",
        Done: false,
        URL: "https://www.geeksforgeeks.org/printing-solutions-n-queen-problem/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "BackTracking",
        Problem: "Solve the sudoku",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/solve-the-sudoku-1587115621/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "BackTracking",
        Problem: "Partition equal subset sum",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/subset-sum-problem2014/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "BackTracking",
        Problem: "M coloring problem",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/m-coloring-problem-1587115620/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "BackTracking",
        Problem: "Knight tour",
        Done: false,
        URL: "https://www.geeksforgeeks.org/the-knights-tour-problem-backtracking-1/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "BackTracking",
        Problem: "Sudoku",
        Done: false,
        URL: "https://www.geeksforgeeks.org/sudoku-backtracking-7/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "BackTracking",
        Problem: "Remove invalid paranthesis",
        Done: false,
        URL: "https://www.geeksforgeeks.org/remove-invalid-parentheses/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "BackTracking",
        Problem: "World break problem using backtracking",
        Done: false,
        URL: "https://www.geeksforgeeks.org/word-break-problem-using-backtracking/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "BackTracking",
        Problem: "Print all palindromic partitions of a string",
        Done: false,
        URL: "https://www.geeksforgeeks.org/print-palindromic-partitions-string/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "BackTracking",
        Problem: "Find shortest safe route in a path with landmines",
        Done: false,
        URL: "https://www.geeksforgeeks.org/find-shortest-safe-route-in-a-path-with-landmines/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "BackTracking",
        Problem: "Partition of set-7 hamiltonian cycle",
        Done: false,
        URL: "https://www.geeksforgeeks.org/partition-set-k-subsets-equal-sum/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "BackTracking",
        Problem: "Tug of war",
        Done: false,
        URL: "https://www.geeksforgeeks.org/tug-of-war/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "BackTracking",
        Problem: "Maximum possible no. by doing at most K swaps",
        Done: false,
        URL: "https://www.geeksforgeeks.org/find-maximum-number-possible-by-doing-at-most-k-swaps/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "BackTracking",
        Problem: "Backtracking set-8 solving cryptarithmatic puzzles",
        Done: false,
        URL: "https://www.geeksforgeeks.org/solving-cryptarithmetic-puzzles-backtracking-8/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "BackTracking",
        Problem: "Find paths from corner cell to middle cell in maze",
        Done: false,
        URL: "https://www.geeksforgeeks.org/find-paths-from-corner-cell-to-middle-cell-in-maze/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "BackTracking",
        Problem: "Arithmatic expressions",
        Done: false,
        URL: "https://www.hackerrank.com/challenges/arithmetic-expressions/problem",
        Platform: "hackerrank",
      },
    ],
  },
  {
    topicName: "Stacks & Queues",
    position: 9,
    started: false,
    doneQuestions: 0,
    questions: [
      {
        Topic: "Stacks & Queues",
        Problem: "Implement two stacks in an array",
        Done: false,
        URL: "https://www.geeksforgeeks.org/implement-two-stacks-in-an-array/",
        Platform: "geekforgeeks",
      },
      {
        Topic: "Stacks & Queues",
        Problem: "Evaluation of postfix expression",
        Done: false,
        URL: "https://www.geeksforgeeks.org/stack-set-4-evaluation-postfix-expression/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Stacks & Queues",
        Problem: "Implement stack using queues",
        Done: false,
        URL: "https://leetcode.com/problems/implement-stack-using-queues/",
        Platform: "leetcode",
      },
      {
        Topic: "Stacks & Queues",
        Problem: "Queue reversal",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/queue-reversal/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Stacks & Queues",
        Problem: "Implement stack queue using deque",
        Done: false,
        URL: "https://www.geeksforgeeks.org/implement-stack-queue-using-deque/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Stacks & Queues",
        Problem: "Reverse first K elements of queue",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/reverse-first-k-elements-of-queue/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Stacks & Queues",
        Problem: "Design stack with middle operation",
        Done: false,
        URL: "https://www.geeksforgeeks.org/design-a-stack-with-find-middle-operation/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Stacks & Queues",
        Problem: "Infix to postfix",
        Done: false,
        URL: "https://www.geeksforgeeks.org/convert-infix-expression-to-postfix-expression/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Stacks & Queues",
        Problem: "Design  and implement special stack",
        Done: false,
        URL: "https://www.geeksforgeeks.org/design-and-implement-special-stack-data-structure/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Stacks & Queues",
        Problem: "Longest valid string",
        Done: false,
        URL: "https://www.geeksforgeeks.org/length-of-the-longest-valid-substring/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Stacks & Queues",
        Problem: "Find if an expression has duplicate parenthesis or not",
        Done: false,
        URL: "https://www.geeksforgeeks.org/find-expression-duplicate-parenthesis-not/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Stacks & Queues",
        Problem:
          "Stack permutations check if an array is stack permutation of other",
        Done: false,
        URL: "https://www.geeksforgeeks.org/stack-permutations-check-if-an-array-is-stack-permutation-of-other/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Stacks & Queues",
        Problem: "Count natural numbers whose permutation greater number",
        Done: false,
        URL: "https://www.geeksforgeeks.org/count-natural-numbers-whose-permutation-greater-number/",
        Platform: "geekforgeeks",
      },
      {
        Topic: "Stacks & Queues",
        Problem: "Sort a stack using recursion",
        Done: false,
        URL: "https://www.geeksforgeeks.org/sort-a-stack-using-recursion/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Stacks & Queues",
        Problem:
          "Queue based approach for first non repeating character in a stream",
        Done: false,
        URL: "https://www.geeksforgeeks.org/queue-based-approach-for-first-non-repeating-character-in-a-stream/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Stacks & Queues",
        Problem: "The celebrity problem",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/the-celebrity-problem/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Stacks & Queues",
        Problem: "Iterative tpwer of hanoi",
        Done: false,
        URL: "https://www.geeksforgeeks.org/iterative-tower-of-hanoi/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Stacks & Queues",
        Problem:
          "Find the maximum for minimum for every window size in a given array",
        Done: false,
        URL: "https://www.geeksforgeeks.org/find-the-maximum-of-minimums-for-every-window-size-in-a-given-array/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Stacks & Queues",
        Problem: "Iru cache implementation",
        Done: false,
        URL: "https://www.geeksforgeeks.org/lru-cache-implementation/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Stacks & Queues",
        Problem: "Find a tour that visits all stations",
        Done: false,
        URL: "https://www.geeksforgeeks.org/find-a-tour-that-visits-all-stations/",
        Platform: "geeksforgeeks",
      },
    ],
  },
  {
    topicName: "Heap and Hashing",
    position: 10,
    started: false,
    doneQuestions: 0,
    questions: [
      {
        Topic: "Heap and Hashing",
        Problem:
          "Choose k array elements such that difference of maximum and minimum is minimized",
        Done: false,
        URL: "https://www.geeksforgeeks.org/k-numbers-difference-maximum-minimum-k-number-minimized/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Heap and Hashing",
        Problem: "Heap sort",
        Done: false,
        URL: "https://www.geeksforgeeks.org/heap-sort/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Heap and Hashing",
        Problem: "Top k frequent elements",
        Done: false,
        URL: "https://leetcode.com/problems/top-k-frequent-elements/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Heap and Hashing",
        Problem: "K largest elements in an array",
        Done: false,
        URL: "https://www.geeksforgeeks.org/k-largestor-smallest-elements-in-an-array/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Heap and Hashing",
        Problem: "Next greater element",
        Done: false,
        URL: "https://www.geeksforgeeks.org/next-greater-element/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Heap and Hashing",
        Problem:
          "Kth smallest element after removing some integers from natural numbers",
        Done: false,
        URL: "https://www.geeksforgeeks.org/kth-smallestlargest-element-unsorted-array/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Heap and Hashing",
        Problem: "Find k closest elements to a given value",
        Done: false,
        URL: "https://www.geeksforgeeks.org/find-k-closest-elements-given-value/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Heap and Hashing",
        Problem: "Kth largest element in a stream",
        Done: false,
        URL: "https://www.geeksforgeeks.org/kth-largest-element-in-a-stream/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Heap and Hashing",
        Problem: "Connect ropes",
        Done: false,
        URL: "https://www.geeksforgeeks.org/connect-n-ropes-minimum-cost/",
        Platform: "geekforgeeks",
      },
      {
        Topic: "Heap and Hashing",
        Problem: "Cuckoo hashing",
        Done: false,
        URL: "https://www.geeksforgeeks.org/cuckoo-hashing/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Heap and Hashing",
        Problem: "Itenary from a list of items",
        Done: false,
        URL: "https://www.geeksforgeeks.org/find-itinerary-from-a-given-list-of-tickets/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Heap and Hashing",
        Problem: "Largest subarray with 0 sum",
        Done: false,
        URL: "https://www.geeksforgeeks.org/find-the-largest-subarray-with-0-sum/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Heap and Hashing",
        Problem: "Count distinct elements in every window of size k",
        Done: false,
        URL: "https://www.geeksforgeeks.org/count-distinct-elements-in-every-window-of-size-k/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Heap and Hashing",
        Problem: "Group shifted strings",
        Done: false,
        URL: "https://www.geeksforgeeks.org/group-shifted-string/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Heap and Hashing",
        Problem: "Merge K sorted lists",
        Done: false,
        URL: "https://leetcode.com/problems/merge-k-sorted-lists/",
        Platform: "leetcode",
      },
      {
        Topic: "Heap and Hashing",
        Problem: "Find median from data stream",
        Done: false,
        URL: "https://leetcode.com/problems/find-median-from-data-stream/",
        Platform: "leetcode",
      },
      {
        Topic: "Heap and Hashing",
        Problem: "Sliding window maximum",
        Done: false,
        URL: "https://www.geeksforgeeks.org/sliding-window-maximum-maximum-of-all-subarrays-of-size-k/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Heap and Hashing",
        Problem: "Find surpasser count of each element in array",
        Done: false,
        URL: "https://www.geeksforgeeks.org/find-surpasser-count-of-each-element-in-array/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Heap and Hashing",
        Problem: "Tournament tree and binary heap",
        Done: false,
        URL: "https://www.geeksforgeeks.org/tournament-tree-and-binary-heap/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Heap and Hashing",
        Problem: "Check for palindrome",
        Done: false,
        URL: "https://www.geeksforgeeks.org/online-algorithm-for-checking-palindrome-in-a-stream/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Heap and Hashing",
        Problem: "Length of the largest subarray with continuous elements",
        Done: false,
        URL: "https://www.geeksforgeeks.org/length-largest-subarray-contiguous-elements-set-2/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Heap and Hashing",
        Problem: "Palindrome substring queries",
        Done: false,
        URL: "https://www.geeksforgeeks.org/palindrome-substring-queries/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Heap and Hashing",
        Problem: "Subarray distinct elements",
        Done: false,
        URL: "https://www.geeksforgeeks.org/subarrays-distinct-elements/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Heap and Hashing",
        Problem: "Find the recurring function",
        Done: false,
        URL: "https://www.geeksforgeeks.org/find-recurring-sequence-fraction/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Heap and Hashing",
        Problem: "K maximum sum combinations from two arrays",
        Done: false,
        URL: "https://www.geeksforgeeks.org/k-maximum-sum-combinations-two-arrays/",
        Platform: "geeksforgeeks",
      },
    ],
  },
  {
    topicName: "Graph",
    position: 11,
    started: false,
    doneQuestions: 0,
    questions: [
      {
        Topic: "Graph",
        Problem: "BFS",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/bfs-traversal-of-graph/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Graph",
        Problem: "DFS",
        Done: false,
        URL: "https://www.geeksforgeeks.org/depth-first-search-or-dfs-for-a-graph/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Graph",
        Problem: "Flood fill algorithm",
        Done: false,
        URL: "https://leetcode.com/problems/flood-fill/",
        Platform: "leetcode",
      },
      {
        Topic: "Graph",
        Problem: "Number of triangles",
        Done: false,
        URL: "https://www.geeksforgeeks.org/number-of-triangles-in-directed-and-undirected-graphs/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Graph",
        Problem: "Detect cycle in a graph",
        Done: false,
        URL: "https://www.geeksforgeeks.org/detect-cycle-in-a-graph/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Graph",
        Problem: "Detect cycle in an undirected graph",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/detect-cycle-in-an-undirected-graph/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Graph",
        Problem: "Rat in a maze problem",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/rat-in-a-maze-problem/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Graph",
        Problem: "Steps by knight",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/steps-by-knight5927/1",
        Platform: "geekforgeeks",
      },
      {
        Topic: "Graph",
        Problem: "Clone graph",
        Done: false,
        URL: "https://leetcode.com/problems/clone-graph/",
        Platform: "leetcode",
      },
      {
        Topic: "Graph",
        Problem: "Number of operations to make network connected",
        Done: false,
        URL: "https://leetcode.com/problems/number-of-operations-to-make-network-connected/",
        Platform: "leetcode",
      },
      {
        Topic: "Graph",
        Problem: "Dijkstra's shortest path algorithm",
        Done: false,
        URL: "https://www.geeksforgeeks.org/dijkstras-shortest-path-algorithm-greedy-algo-7/",
        Platform: "geekforgeeks",
      },
      {
        Topic: "Graph",
        Problem: "Topological sort",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/topological-sort/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Graph",
        Problem: "Oliver and the game",
        Done: false,
        URL: "https://www.hackerearth.com/practice/algorithms/graphs/topological-sort/practice-problems/algorithm/oliver-and-the-game-3/",
        Platform: "hackerearth",
      },
      {
        Topic: "Graph",
        Problem:
          "Minimum time taken by each job to be completed given by a directed acyclyic graph",
        Done: false,
        URL: "https://www.geeksforgeeks.org/minimum-time-taken-by-each-job-to-be-completed-given-by-a-directed-acyclic-graph/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Graph",
        Problem:
          "Find whether it is possible to finish all tasks or not from given dependencies",
        Done: false,
        URL: "https://www.geeksforgeeks.org/find-whether-it-is-possible-to-finish-all-tasks-or-not-from-given-dependencies/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Graph",
        Problem: "Find number of islands",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/find-the-number-of-islands/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Graph",
        Problem: "Prim;s algo",
        Done: false,
        URL: "https://www.geeksforgeeks.org/prims-minimum-spanning-tree-mst-greedy-algo-5/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Graph",
        Problem: "Negative weighted cycle",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/negative-weight-cycle3504/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Graph",
        Problem: "Floyd warshall",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/implementing-floyd-warshall2042/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Graph",
        Problem: "Graph coloring",
        Done: false,
        URL: "https://www.geeksforgeeks.org/graph-coloring-applications/#:~:text=Graph%20coloring%20problem%20is%20to,are%20colored%20using%20same%20color.",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Graph",
        Problem: "Snakes and ladders",
        Done: false,
        URL: "https://leetcode.com/problems/snakes-and-ladders/",
        Platform: "leetcode",
      },
      {
        Topic: "Graph",
        Problem: "Kosaraju's theorem",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/strongly-connected-components-kosarajus-algo/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Graph",
        Problem: "Journey to moon",
        Done: false,
        URL: "https://www.hackerrank.com/challenges/journey-to-the-moon/problem",
        Platform: "hackerrank",
      },
      {
        Topic: "Graph",
        Problem: "Vertex cover",
        Done: false,
        URL: "https://www.geeksforgeeks.org/vertex-cover-problem-set-1-introduction-approximate-algorithm-2/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Graph",
        Problem: "M coloring problem",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/m-coloring-problem-1587115620/1",
        Platform: "geekforgeeks",
      },
      {
        Topic: "Graph",
        Problem: "Cheapest flights within K stops",
        Done: false,
        URL: "https://leetcode.com/problems/cheapest-flights-within-k-stops/description/",
        Platform: "leetcode",
      },
      {
        Topic: "Graph",
        Problem: "Find if there is a path of more than k length from a source",
        Done: false,
        URL: "https://www.geeksforgeeks.org/find-if-there-is-a-path-of-more-than-k-length-from-a-source/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Graph",
        Problem: "Bellman Ford",
        Done: false,
        URL: "https://www.geeksforgeeks.org/detect-negative-cycle-graph-bellman-ford/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Graph",
        Problem: "Bipartitie graph",
        Done: false,
        URL: "https://www.geeksforgeeks.org/bipartite-graph/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Graph",
        Problem: "Word ladder",
        Done: false,
        URL: "https://leetcode.com/problems/word-ladder/",
        Platform: "leetcode",
      },
      {
        Topic: "Graph",
        Problem: "Allen Dictionary",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/alien-dictionary/1",
        Platform: "geekforgeeks",
      },
      {
        Topic: "Graph",
        Problem: "Kruskals MST",
        Done: false,
        URL: "https://www.geeksforgeeks.org/kruskals-minimum-spanning-tree-algorithm-greedy-algo-2/",
        Platform: "geekforgeeks",
      },
      {
        Topic: "Graph",
        Problem: "Total number spanning trees graph",
        Done: false,
        URL: "https://www.geeksforgeeks.org/total-number-spanning-trees-graph/",
        Platform: "geekforgeeks",
      },
      {
        Topic: "Graph",
        Problem: "Travelling slaesman",
        Done: false,
        URL: "https://www.geeksforgeeks.org/travelling-salesman-problem-set-1/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Graph",
        Problem: "Find the longest path directed acyclic graph",
        Done: false,
        URL: "https://www.geeksforgeeks.org/find-longest-path-directed-acyclic-graph/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Graph",
        Problem: "Two clique problem",
        Done: false,
        URL: "https://www.geeksforgeeks.org/two-clique-problem-check-graph-can-divided-two-cliques/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Graph",
        Problem: "Minimize the cash flow",
        Done: false,
        URL: "https://www.geeksforgeeks.org/minimize-cash-flow-among-given-set-friends-borrowed-money/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Graph",
        Problem: "Chinese postman",
        Done: false,
        URL: "https://www.geeksforgeeks.org/chinese-postman-route-inspection-set-1-introduction/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Graph",
        Problem: "Water jug",
        Done: false,
        URL: "hhttps://www.geeksforgeeks.org/water-jug-problem-using-bfs/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Graph",
        Problem: "WAter jug 2",
        Done: false,
        URL: "https://www.geeksforgeeks.org/water-jug-problem-using-bfs/",
        Platform: "geeksforgeeks",
      },
    ],
  },
  {
    topicName: "Trie",
    position: 12,
    started: false,
    doneQuestions: 0,
    questions: [
      {
        Topic: "Trie",
        Problem: "Construct a trie from scratch",
        Done: false,
        URL: "https://www.geeksforgeeks.org/trie-insert-and-search/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Trie",
        Problem: "Find shortest unique prefix for every word in a given list",
        Done: false,
        URL: "https://www.geeksforgeeks.org/find-all-shortest-unique-prefixes-to-represent-each-word-in-a-given-list/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Trie",
        Problem: "Word Break Problem | (Trie solution)",
        Done: false,
        URL: "https://www.geeksforgeeks.org/word-break-problem-trie-solution/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Trie",
        Problem: "Given a sequence of words, print all anagrams together",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/k-anagrams-1/0",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Trie",
        Problem: "Implement a Phone Directory",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/phone-directory/0",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Trie",
        Problem: "Print unique rows in a given boolean matrix",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/unique-rows-in-boolean-matrix/1",
        Platform: "geeksforgeeks",
      },
    ],
  },
  {
    topicName: "Dynamic Programming",
    position: 13,
    started: false,
    doneQuestions: 0,
    questions: [
      {
        Topic: "Dynamic Programming",
        Problem: "Knapsack with duplicate items",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/knapsack-with-duplicate-items4201/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "BBT counter",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/bbt-counter4914/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Reach a given score",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/reach-a-given-score-1587115621/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Maximum difference of zeroes and ones in binary string",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/maximum-difference-of-zeros-and-ones-in-binary-string4111/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Climbing stairs",
        Done: false,
        URL: "https://leetcode.com/problems/climbing-stairs/",
        Platform: "leeetcode",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Permutation coefficient",
        Done: false,
        URL: "https://www.geeksforgeeks.org/permutation-coefficient/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Longest repeating subsequence",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/longest-repeating-subsequence2004/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Pairs with specific difference",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/pairs-with-specific-difference1533/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Coin change",
        Done: false,
        URL: "https://leetcode.com/problems/coin-change/",
        Platform: "leetcode",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "LIS",
        Done: false,
        URL: "https://leetcode.com/problems/longest-increasing-subsequence/",
        Platform: "leetcode",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Longest common subsequence",
        Done: false,
        URL: "https://leetcode.com/problems/longest-common-subsequence/",
        Platform: "leetcode",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Word break",
        Done: false,
        URL: "https://leetcode.com/problems/word-break/",
        Platform: "leetcode",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Combination sum IV",
        Done: false,
        URL: "https://leetcode.com/problems/combination-sum-iv/",
        Platform: "leetcode",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "House robber",
        Done: false,
        URL: "https://leetcode.com/problems/house-robber/",
        Platform: "leetcode",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "House robber 2",
        Done: false,
        URL: "https://leetcode.com/problems/house-robber-ii/",
        Platform: "leetcode",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Decode ways",
        Done: false,
        URL: "https://leetcode.com/problems/decode-ways/",
        Platform: "leetcode",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Unique paths",
        Done: false,
        URL: "https://leetcode.com/problems/unique-paths/",
        Platform: "leetcode",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Jumps game",
        Done: false,
        URL: "https://leetcode.com/problems/jump-game/",
        Platform: "leetcode",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Knapsack problem",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/0-1-knapsack-problem0945/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "nCr",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/ncr1019/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Catalan number",
        Done: false,
        URL: "https://www.geeksforgeeks.org/program-nth-catalan-number/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Edit distance",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/edit-distance3702/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Subset sum",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/subset-sum-problem2014/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Gold mine",
        Done: false,
        URL: "https://www.geeksforgeeks.org/gold-mine-problem/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Assembly line scheduling",
        Done: false,
        URL: "https://www.geeksforgeeks.org/assembly-line-scheduling-dp-34/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Maximize the cut segments",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/cutted-segments1642/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Maximum sum increasing subsequence",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/maximum-sum-increasing-subsequence4749/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Egg dropping puzzle",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/egg-dropping-puzzle-1587115620/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Max length chain",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/max-length-chain/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Largest square in matrix",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/largest-square-formed-in-a-matrix0806/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Maximum path sum",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/path-in-matrix3805/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Minimum number of jumps",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/minimum-number-of-jumps-1587115620/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Minimum removals from array to make max-min<=K",
        Done: false,
        URL: "https://www.geeksforgeeks.org/minimum-removals-array-make-max-min-k/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Longest palindromic subsequence",
        Done: false,
        URL: "https://www.geeksforgeeks.org/longest-palindromic-subsequence-dp-12/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Count palindromic subsequence",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/count-palindromic-subsequences/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Longest palindromic substring",
        Done: false,
        URL: "https://leetcode.com/problems/longest-palindromic-substring/",
        Platform: "leetcode",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Longest alternating sequence",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/longest-alternating-subsequence5951/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Weighted job sequence",
        Done: false,
        URL: "https://www.geeksforgeeks.org/weighted-job-scheduling/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Coin game",
        Done: false,
        URL: "https://www.geeksforgeeks.org/coin-game-winner-every-player-three-choices/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Coin game winner",
        Done: false,
        URL: "https://www.geeksforgeeks.org/count-derangements-permutation-such-that-no-element-appears-in-its-original-position/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Optimal strategy for a game",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/optimal-strategy-for-a-game-1587115620/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Word wrap",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/word-wrap1646/1",
        Platform: "leetcode",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Mobile numeric keypad",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/mobile-numeric-keypad5456/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Maximum length of pair chain",
        Done: false,
        URL: "https://leetcode.com/problems/maximum-length-of-pair-chain/",
        Platform: "leetcode",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Matrix chain multiplication",
        Done: false,
        URL: "https://www.geeksforgeeks.org/matrix-chain-multiplication-dp-8/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Maximum profit of buying selling a share at most twice",
        Done: false,
        URL: "https://www.geeksforgeeks.org/maximum-profit-by-buying-and-selling-a-share-at-most-twice/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Optimal BST",
        Done: false,
        URL: "https://www.geeksforgeeks.org/optimal-binary-search-tree-dp-24/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Dynamic Programming",
        Problem: "Largest submatrix with sum 0",
        Done: false,
        URL: "https://www.geeksforgeeks.org/largest-rectangular-sub-matrix-whose-sum-0/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Dynamic Programming",
        Problem:
          "Largest area rectangular sub-matrix with equal no. of 1's and 0's",
        Done: false,
        URL: "https://www.geeksforgeeks.org/largest-area-rectangular-sub-matrix-equal-number-1s-0s/",
        Platform: "geeksforgeeks",
      },
    ],
  },
  {
    topicName: "Bit Manipulation",
    position: 14,
    started: false,
    doneQuestions: 0,
    questions: [
      {
        Topic: "Bit Manipulation",
        Problem: "Count set bits in an integer",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/set-bits0143/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Bit Manipulation",
        Problem:
          "Find the two non-repeating elements in an array of repeating elements",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/finding-the-numbers0215/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Bit Manipulation",
        Problem: "Count number of bits to be flipped to convert A to B",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/bit-difference/0",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Bit Manipulation",
        Problem: "Count total set bits in all numbers from 1 to n",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/count-total-set-bits/0",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Bit Manipulation",
        Problem: "Program to find whether a no is power of two",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/power-of-2/0",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Bit Manipulation",
        Problem: "Find position of the only set bit",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/find-position-of-set-bit3706/1",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Bit Manipulation",
        Problem: "Copy set bits in a range",
        Done: false,
        URL: "https://www.geeksforgeeks.org/copy-set-bits-in-a-range/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Bit Manipulation",
        Problem:
          "Divide two integers without using multiplication, division and mod operator",
        Done: false,
        URL: "https://www.geeksforgeeks.org/divide-two-integers-without-using-multiplication-division-mod-operator/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Bit Manipulation",
        Problem: "Calculate square of a number without using *, / and pow()",
        Done: false,
        URL: "https://www.geeksforgeeks.org/calculate-square-of-a-number-without-using-and-pow/",
        Platform: "geeksforgeeks",
      },
      {
        Topic: "Bit Manipulation",
        Problem: "Power Set",
        Done: false,
        URL: "https://practice.geeksforgeeks.org/problems/power-set4302/1",
        Platform: "geeksforgeeks",
      },
    ],
  },
  {
    topicName: "Segment trees",
    position: 15,
    started: false,
    doneQuestions: 0,
    questions: [
      {
        Topic: "Segment trees",
        Problem: "Range sum query - immutable",
        Done: false,
        URL: "https://leetcode.com/problems/range-sum-query-immutable/",
        Platform: "leetcode",
      },
      {
        Topic: "Segment trees",
        Problem: "Range minimum query",
        Done: false,
        URL: "https://cp-algorithms.com/sequences/rmq.html",
        Platform: "cp-algorithms",
      },
      {
        Topic: "Segment trees",
        Problem: "Range sum query - mutable",
        Done: false,
        URL: "https://leetcode.com/problems/range-sum-query-mutable/",
        Platform: "leetcode",
      },
      {
        Topic: "Segment trees",
        Problem: "Create sorted array through instructions",
        Done: false,
        URL: "https://leetcode.com/problems/create-sorted-array-through-instructions/",
        Platform: "leetcode",
      },
      {
        Topic: "Segment trees",
        Problem: "Count range sum",
        Done: false,
        URL: "https://leetcode.com/problems/count-of-range-sum/",
        Platform: "leetcode",
      },
      {
        Topic: "Segment trees",
        Problem: "Count of smaller numbers after self",
        Done: false,
        URL: "https://leetcode.com/problems/count-of-smaller-numbers-after-self/",
        Platform: "leetcode",
      },
    ],
  },
];

export default apnaCollege;
